import type { LucideProps } from "lucide-react";

import {
  CalendarClock,
  Download,
  GraduationCap,
  Handshake,
  KeyRound,
  LockOpen,
  PackageOpen,
  Repeat,
  Shirt,
} from "lucide-react";

interface ProductTypeOption {
  value: string;
  title: string;
  label: string;
  description: string;
  icon: React.ComponentType<LucideProps>;
  color: string;
}

export const PRODUCT_TYPE_OPTIONS: ProductTypeOption[] = [
  {
    value: "DIGITAL",
    title: "File Download",
    label: "File Download",
    description:
      "All digital files like PDFs, images, templates, or design assets.",
    icon: Download,
    color: "pink",
  },
  {
    value: "PHYSICAL",
    title: "Physical",
    label: "Physical",
    description: "Sell tangible products that you ship to customers.",
    icon: Shirt,
    color: "violet",
  },
  {
    value: "SERVICE",
    title: "Service",
    label: "Service",
    description: "Offer services ranging from expertise to local offerings.",
    icon: Handshake,
    color: "lime",
  },
  {
    value: "DIGITAL",
    title: "Access Code / Key",
    label: "Access Code / Key",
    description: "Sell license keys, discount codes, or unlock codes.",
    icon: KeyRound,
    color: "orange",
  },
  {
    value: "SOFTWARE",
    title: "Software",
    label: "Software",
    description: "Sell apps or tools as one-time purchases or subscriptions.",
    icon: Repeat,
    color: "teal",
  },
  {
    value: "EVENT",
    title: "Events / Experience",
    label: "Events / Experience",
    description:
      "Sell tickets or access to workshops, classes, or live events.",
    icon: CalendarClock,
    color: "sky",
  },
  {
    value: "MEMBERSHIP",
    title: "Membership / Content",
    label: "Membership / Content",
    description:
      "Sell access to gated communities or exclusive content libraries.",
    icon: LockOpen,
    color: "fuchsia",
  },
  {
    value: "COURSE",
    title: "Course",
    label: "Course",
    description:
      "Sell structured lessons, training programs, or online classes.",
    icon: GraduationCap,
    color: "yellow",
  },
  {
    value: "RETAIL",
    title: "Other",
    label: "Other",
    description: "Sell products that don't fit a standard category.",
    icon: PackageOpen,
    color: "zinc",
  },
];
